import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { StatusCard } from '@node-space/storybook-components/dist/StatusCard'
import {
  ActionList,
  ActionListChildren,
  Box,
  Callout,
  Input,
  Text,
} from '@node-space/ui-components'
import NoSearchResults from 'components/NoSearchResults/NoSearchResults'

export interface CustomerWalletsProps {
  isCustomerVerified: boolean
  customerName: string
  searchQuery: string
  isSearching: boolean
  walletTableRows: ActionListChildren[]
  AddWalletButton: ReactNode
  onChangeSearchQuery: (searchQuery: string) => void
}

export const CustomerWallets = ({
  isCustomerVerified,
  customerName,
  searchQuery,
  isSearching,
  walletTableRows,
  AddWalletButton,
  onChangeSearchQuery,
}: CustomerWalletsProps) => {
  const { t } = useTranslation()
  const hasWallets = !!walletTableRows?.length

  if (hasWallets || isSearching) {
    return (
      <>
        <Box paddingB={16} width="full">
          <Input
            value={searchQuery}
            testId="customer-wallet-search-field"
            placeholder={t('customers.customerWalletSearchPlaceholder')}
            searchable
            onChange={event => onChangeSearchQuery(event.target.value)}
          />
        </Box>
        {!isCustomerVerified && (
          <Box paddingB={16}>
            <Callout>
              <Text color="inherit">{t('customers.inactiveCustomerInfoMessage')}</Text>
            </Callout>
          </Box>
        )}
        {hasWallets ? (
          <ActionList id="customer-wallets-action-list" items={walletTableRows} />
        ) : (
          <NoSearchResults clearSearchCriteria={() => onChangeSearchQuery('')} />
        )}
      </>
    )
  }

  if (!isCustomerVerified) {
    return (
      <StatusCard
        headline={t('customers.walletRestriction.customerNotVerifiedTitle')}
        description={t('customers.walletRestriction.customerNotVerifiedDescription')}
      />
    )
  }

  return (
    <StatusCard
      headline={t('customers.noCustomerWalletHeadline', { customerName })}
      description={t('customers.customerWalletDescription', { customerName })}
    >
      {AddWalletButton && <Box paddingT={12}>{AddWalletButton}</Box>}
    </StatusCard>
  )
}
